import { UserProfile } from "./user-profile";
import { z } from "zod";
export const UserSource = z.enum(["SignUp", "Invite", "SSO", "Google"]);
export const UserEmailSettings = z.object({
    marketingEmails: z.boolean(),
});
export const User = z.object({
    id: z.string(),
    email: z.string(),
    createdAt: z.coerce.date(),
    profile: UserProfile,
    loggedOutAt: z.coerce.date().optional(),
    isProtected: z.boolean(),
    source: UserSource.optional(),
    emailSettings: UserEmailSettings.optional(),
});
